export { default } from './GeneralConditions';
